import {
  ButtonProps,
  HeadingProps,
  IconButtonProps,
} from "@origin-digital/ods-core";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";

export const usePageTitleSection = () => {
  const {
    context: { featureFlags, project },
    setContext,
  } = useAppContext();
  const navigate = useNavigate();

  const backIconButtonProps: Partial<IconButtonProps> = React.useMemo(() => {
    return {
      onClick: () => {
        setContext({ project: undefined, requestingCompany: undefined });
        navigate("/projects");
      },
      "data-id": "pageTitleSection.backIconButton",
    };
  }, [setContext, navigate]);

  const headingProps: Omit<HeadingProps, "variant"> = React.useMemo(() => {
    return {
      children: project?.name || "",
      "data-id": "pageTitleSection.heading",
    };
  }, [project, featureFlags]);

  const editProjectButtonProps: ButtonProps = React.useMemo(() => {
    return {
      "data-id": "pageTitleSection.editProjectButton",
    };
  }, []);

  return {
    featureFlags,
    backIconButtonProps,
    headingProps,
    editProjectButtonProps,
  };
};
